/**
 * Creatable functionality for MultiSelect (Vanilla JS)
 * Allows users to create new options by typing custom values
 */
export class Creatable {
    constructor(multiSelect) {
        this.ms = multiSelect;
        this.createOptionRow = null;
    }

    showCreateOption(value) {
        this.removeCreateOption();

        if (!value.trim() || this.optionExists(value)) {
            return;
        }

        const text = this.ms.creatableText.replace('{value}', value);
        const html = `<div class="form-check no-checkbox form-check-create" data-create-value="${this.escapeHtml(value)}">
            <label class="form-check-label">${this.escapeHtml(text)}</label>
        </div>`;

        const optionsList = this.ms.menuBody?.querySelector('.options-list') ?? this.ms.menuBody;

        if (optionsList) {
            optionsList.insertAdjacentHTML('afterbegin', html);
            this.createOptionRow = optionsList.querySelector('.form-check-create');
        }
    }

    removeCreateOption() {
        if (this.createOptionRow) {
            this.createOptionRow.remove();
            this.createOptionRow = null;
        }
    }

    optionExists(value) {
        const escapedValue = CSS.escape(value);

        return !!this.ms.select.querySelector(`option[value="${escapedValue}"]`);
    }

    createOption(value) {
        const option = document.createElement('option');
        option.value = value;
        option.text = value;
        option.selected = true;
        this.ms.select.appendChild(option);
        this.ms.updateSelection();
        this.removeCreateOption();

        if (this.ms.search.searchInput) {
            this.ms.search.searchInput.value = '';
            this.ms.search.searchInput.dispatchEvent(new Event('input'));
        }
    }

    handleClick(target) {
        const createOption = target.closest('.form-check-create');

        if (createOption) {
            const value = createOption.dataset.createValue;

            if (value) {
                this.createOption(value);
            }

            return true;
        }

        return false;
    }

    handleEnterKey() {
        if (!this.createOptionRow) {
            return false;
        }

        const value = this.createOptionRow.dataset.createValue;

        if (value) {
            this.createOption(value);

            return true;
        }

        return false;
    }

    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;

        return div.innerHTML;
    }
}